import _ from 'lodash';
import createLocationModel, { prop } from './lib/create_location_model';
import PerformanceDateRange from 'models/performance_date_range';

const AnswerPerformanceView = createLocationModel({
  modelName: 'AnswerPerformanceView',
  properties: {
    audienceId: prop(String),
    dateRange: prop()
      .oneOf(...Object.values(PerformanceDateRange))
      .default(PerformanceDateRange.LAST_1_DAY),
    sort: prop({
      key: prop(String).isRequired,
      direction: prop().oneOf('asc', 'desc'),
    }),
  },

  deriveNew(newQuery) {
    return AnswerPerformanceView.create(_.assign({}, this, newQuery));
  },

  statics: {
    breadcrumb: 'Answer Performance',
  },
});

export default AnswerPerformanceView;
